import { Cancel, Download, HourglassEmpty } from "@mui/icons-material";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useMemo } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
    type MRT_ColumnDef,
} from 'material-react-table';
import { GridCheckCircleIcon } from "@mui/x-data-grid";
import { toast } from "react-toastify";

type PaymentHistory = {
    amountPaid: string;
    createdAt: string; // ISO date string
    currency?: string;
    customerId?: string;
    expiryDate?: string; // ISO date string
    id: number;
    invoiceId?: string;
    invoiceUrl?: string;
    mode: string;
    paymentStatus: string;
    paymentType: string;
    productDescription?: string;
    productName?: string;
    sessionId?: string;
    stripePriceId?: string;
    stripeProductId?: string;
    subscriptionId?: string;

};

type CompProps = {
    allPlans : PaymentHistory[]
}



export default function PaymentHistory({allPlans} : CompProps) {

    const paymentHistory : PaymentHistory[] = allPlans;
    console.log(paymentHistory, "paymentHistory");

    function formatDate(isoString: string): string {
        return new Date(isoString).toISOString().split('T')[0];
    }

    const columns = useMemo<MRT_ColumnDef<PaymentHistory>[]>(
        () => [
            {
                id: 'rowIndex',
                header: 'ID',
                size: 50,
                Cell: ({ row }) => row.index + 1,
            },
            {
                accessorKey: 'productName',
                header: 'Product Name',
                size: 120,
            },
            // {
            //     accessorKey: 'plan',
            //     header: 'Plan',
            //     size: 100,
            // },
            {
                accessorKey: 'mode',
                header: 'Plan',
                size: 100,
                Cell : ({cell}) => {
                    const value = cell.getValue<string>();
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },

            {
                accessorKey: 'amountPaid',
                header: 'Price',
                size: 100,
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();
                    return (
                        <Box display="flex" alignItems="center">
                            $
                            <Typography variant="body2">{value}</Typography>
                        </Box>
                    );
                },
            },
            {
                accessorKey: 'createdAt',
                header: 'Date',
                size: 100,
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();
                    const formatteDate = formatDate(value);
                    return (
                        <Box display="flex" alignItems="center">
                            <Typography variant="body2">{formatteDate}</Typography>
                        </Box>
                    );
                },
            },
            {
                accessorKey: 'paymentType',
                header: 'Payment Type',
                size: 100,
            },
            // {
            //     accessorKey: 'paymentMethod',
            //     header: 'Payment Method',
            //     size: 150,
            // },
            {
                accessorKey: 'paymentStatus',
                header: 'Status',
                size: 100,
                Cell: ({ cell }) => {
                    const value = cell.getValue<string>();

                    const getIcon = () => {
                        switch (value.toLowerCase()) {
                            case 'paid':
                                return <GridCheckCircleIcon sx={{ color: 'green', fontSize: 18, mr: 0.5 }} />;
                            case 'unpaid':
                                return <Cancel sx={{ color: 'red', fontSize: 18, mr: 0.5 }} />;

                            default:
                                return <HourglassEmpty sx={{ color: 'orange', fontSize: 18, mr: 0.5 }} />;
                        }
                    };

                    return (
                        <Box display="flex" alignItems="center">
                            {getIcon()}
                            <Typography variant="body2">{value}</Typography>
                        </Box>
                    );
                },
                // size: 120,
            },
            {
                id: 'invoiceUrl',
                header: 'Invoice',
                Cell: ({ row }) => {
                    const invoiceUrl = row.original.invoiceUrl;
                    const handleClick = () => {
                        if (invoiceUrl) {
                            const link = document.createElement("a");
                            link.href = invoiceUrl;
                            link.download = "";
                            document.body.appendChild(link)
                            link.click();
                            document.body.removeChild(link);
                            toast.success("Download Started...")
                        }
                    };

                    return (
                        <>
                            <Tooltip title="Download Invoice">
                                <IconButton onClick={handleClick}>
                                    <Download sx={{ cursor: "pointer" }} />
                                </IconButton>
                            </Tooltip>

                        </>
                    );
                },
            },

        ],
        [],
    );

    const data = useMemo<PaymentHistory[]>(
        () => paymentHistory,
        [paymentHistory]
    );


    const table = useMaterialReactTable({
        columns,
        data,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        enableSorting: false,
        enableColumnActions: false,
        muiTableHeadRowProps: {
            sx: {
                height: "60px",

            }
        },
        muiTableBodyRowProps: {
            sx: {
                height: "50px",

            }
        },
        muiTableContainerProps: {
            sx: {
                width: "100%",
                maxWidth: { xs: "300px", sm: "600px", md: "100%" },
                overflowX: { xs: "scroll", lg: "unset" },
            },
        },
        muiTableProps: {
            sx: {
                tableLayout: 'fixed',


            },
        },
        enableFilters: false,
        enableGlobalFilter: false,
        positionToolbarAlertBanner: "none",
        renderTopToolbar: false,
        enableHiding: false,
        initialState: { showColumnFilters: true, density: "compact", },
        muiTablePaperProps: {
            elevation: 0, //change the mui box shadow
            //customize paper styles
            sx: {

                p: "10px 0px 20px 20px"
            },
        },

        //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    });

    return (
        <>
            {paymentHistory.length > 0 ? <MaterialReactTable table={table} /> : (
                <div>
                    No data
                </div>
            )}
        </>
    )
}
